import useFareFamilyInfoApiCall from '../../useFareFamilyInfoApiCall'

const useFareFamilyInfoApi = ({ skip = false }: { skip?: boolean }) => {
    useFareFamilyInfoApiCall(
        {
            skip
        }
    )
}

export default useFareFamilyInfoApi
